module.exports = __webpack_public_path__ + "img/upload_cell_big.92c8026e.gif";